import { Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import Checkbox from "../../../../common/FormComponents/CheckBox";
import Input from "../../../../common/FormComponents/Input";
import Select from "../../../../common/FormComponents/Select";
import { monthLocales } from "../../../../../constant/monthLocales";

const Passport = ({
  control,
  errors,
  pageText,
  DayList,
  getLanguageCode,
}: any) => {
  const getPassportYearList = () => {
    const currentYear = new Date().getFullYear();
    const startYear = currentYear - 0;
    const endYear = currentYear + 20;
    return Array.from({ length: endYear - startYear + 1 }, (_, i) => {
      const year = startYear + i;
      return { label: year.toString(), value: year };
    });
  };

  const passportYearsList = getPassportYearList();

  let languageCode = getLanguageCode();

  return (
    <>
      <Grid xs={12} sm={6} className="field">
        <Input
          name="PassportNo"
          type="text"
          control={control}
          placeholder={pageText?.validationMessages?.pleaseEnterPassportNumber}
          maxLength={12}
          errors={errors}
          label={`${pageText?.labelsMetadata?.passportNoLabel} *`}
          rules={{
            required: pageText?.validationMessages?.pleaseEnterPassportNumber,
          }}
        />
      </Grid>
      <Grid xs={12} className="field" component={Typography} fontSize="14px">
        {pageText?.labelsMetadata.passportExpiryLabel}
      </Grid>
      <Grid xs={12} sm={4} className="field">
        <Select
          label={`${pageText?.labelsMetadata?.day} *`}
          classNamePrefix={"form_drop"}
          placeholder={`${pageText?.labelsMetadata?.selectText}`}
          options={DayList}
          control={control}
          errors={errors}
          name="passportEx.day"
          rules={{
            required: {
              value: true,
              message: pageText?.textMetadata?.pleaseselectday,
            },
          }}
        />
      </Grid>
      <Grid xs={12} sm={4} className="field">
        <Select
          label={`${pageText?.labelsMetadata?.month} *`}
          classNamePrefix={"form_drop"}
          placeholder={`${pageText?.labelsMetadata?.selectText}`}
          options={
            languageCode.substring(0, 2) === "en"
              ? monthLocales["en-GB"]
              : monthLocales[languageCode]
          }
          control={control}
          errors={errors}
          name="passportEx.month"
          rules={{
            required: {
              value: true,
              message: pageText?.textMetadata?.pleaseselectmonth,
            },
          }}
        />
      </Grid>
      <Grid xs={12} sm={4} className="field">
        <Select
          label={`${pageText?.labelsMetadata.year} *`}
          classNamePrefix={"form_drop"}
          placeholder={`${pageText?.labelsMetadata?.selectText}`}
          options={passportYearsList}
          control={control}
          errors={errors}
          name="passportEx.year"
          rules={{
            required: {
              value: true,
              message: pageText?.textMetadata?.pleaseselectyear,
            },
          }}
        />
      </Grid>
      <Grid xs={12} className="field">
        <Checkbox
          control={control}
          name="VoiceConsent"
          errors={errors}
          label={`${pageText?.labelsMetadata?.voiceConsentLabel} *`}
          rules={{
            required: {
              value: true,
              message: pageText?.validationMessages?.pleaseAcceptVoiceConsent,
            },
          }}
        />
      </Grid>
      <Grid xs={12} className="field">
        <Checkbox
          control={control}
          name="UkbaConsent"
          errors={errors}
          label={`${pageText?.labelsMetadata?.ukbaConsentLabel} *`}
          rules={{
            required: {
              value: true,
              message: pageText?.validationMessages?.pleaseAcceptUkbaConsent,
            },
          }}
        />
      </Grid>
    </>
  );
};

export default Passport;
